import { createSelector } from "reselect";

export const getHotelOnly = state => state.hotelOnly;

export const getHotels = createSelector([getHotelOnly], hotelOnly => hotelOnly?.hotels || []);

export const getHotelsLoadingStatus = createSelector(
	[getHotelOnly],
	hotelOnly => hotelOnly?.isLoading || false
);

export const getFacets = state => state.hotelOnly.facets || {};

export const getTotalHotels = createSelector(
	[getHotelOnly],
	hotelOnly => hotelOnly?.metadata?.pagination?.totalItems || 0
);

export const getBookingFlowId = createSelector(
	[getHotelOnly],
	hotelOnly => hotelOnly.bookingFlowId || null
);
